export default "__VITE_ASSET__CpBMRuoR__"